


























































import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'
import Delivery from '@/dto/deliveries/Delivery'
import DictionariesService from '@/services/DictionariesService'
import Currency from '@/dto/deliveries/Currency'
import { Errors } from '@/dto/ErrorsResponse'

@Component
export default class StaticFields extends Vue {
  dictionaries = DictionariesService

  @Prop(Object)
  model: Delivery

  @Prop(Object)
  errors: Errors

  get calculatorTypeOptions() {
    const calculatorTypes = this.dictionaries.calculatorTypes
    const calculatorTypesGroups = this.dictionaries.calculatorTypesGroups
    const allowedCalculatorTypes = calculatorTypesGroups[this.model.type]

    const entries = Object.entries(calculatorTypes)

    const options = entries
      .filter(([type]) => allowedCalculatorTypes.includes(type))
      .map(([type, label]) => ({
        label,
        value: type,
      }))

    options.unshift({ label: 'Не выбран', value: '' })

    return options
  }

  get currentCurrency(): Currency | null {
    if (!this.model.currencyCode) {
      return null
    }

    return this.dictionaries.currencies[this.model.currencyCode]
  }

  get allowedDeliveredDuties() {
    return Object.entries(this.dictionaries.allowedDeliveredDuties).map(
      ([name, value]) => ({
        label: value,
        value: name,
      })
    )
  }

  get currenciesOptions() {
    return this.dictionaries.getCurrenciesOptions()
  }

  get deliveryTypesOptions() {
    return this.dictionaries.getDeliveryTypesOptions()
  }

  resetCalculatorType() {
    this.model.calculatorType = ''
  }
}
